import ProjectLanguageSelector from '../ProjectLanguageSelector';
import TitledTextField from '../TitledTextField';
import ProjectUsers from '../ProjectUsers';
import TitledPanel from '../TitledPanel';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import PrimaryButton from '../PrimaryButton';
import { lightSanitiseText } from '../utils/utils';
import { globalStyles as styles } from '../style/gstheme';
import DialogMultiActions from '../DialogMultiActions';

class CreateTaskDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: "All",
            text: "",
            lang: this.props.defaultLang
        };
    }

    handleUserChange = (user) => this.setState({ user });

    createTask = (notify = false) => () => this.props.onCreateTask(this.props.createdBy, this.state.user, this.state.text, this.state.lang, notify);

    selectLanguage = (lang) => this.setState({ lang });

    handleChange = event => {
        const t = event.target;
        const cleanText = lightSanitiseText(t.value.trimLeft());
        this.setState({ [t.name]: cleanText });
    };

    render() {

        const { classes, onCancel, projectUsers, allowInstructions } = this.props;
        const { text, user, lang } = this.state;

        return (
            <React.Fragment>
                <Dialog
                    data-test="create-task-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paperWidthMd: classes.mediumDialogOverflow
                    }}
                    open={true}
                    onClose={onCancel}
                    aria-labelledby="create-task-dialog-title">
                    <DialogTitle data-test="create-task-title" disableTypography className={classes.mainHeading} id="create-task-dialog-title">Create Task</DialogTitle>
                    <DialogContent data-test="create-task-dialog" style={{
                        maxHeight: '500px',
                        overflowY: 'scroll'
                    }}>
                        <div style={{ marginBottom: allowInstructions ? 0 : 24 }}>
                            <TitledPanel dataTest="assignee" height="full" title="Assign To">
                                <ProjectUsers
                                    projectUsers={projectUsers}
                                    includeLabel={false}
                                    allLabel="Unassigned"
                                    onUserChange={this.handleUserChange} />
                            </TitledPanel>
                        </div>
                        <div>
                            <TitledPanel margin={true} title="Language">
                                <ProjectLanguageSelector
                                    selectedLang={lang}
                                    includeLabel={false}
                                    onSelect={this.selectLanguage} />
                            </TitledPanel>
                            <TitledTextField
                                dataTest="language-text"
                                name="text"
                                title="Instructions"
                                margin={true}
                                autoFocus={true}
                                lang={lang}
                                required={true}
                                placeholder="Enter a description of the task"
                                text={text}
                                multiline={true}
                                rows={3}
                                maxLength={500}
                                onEnter={text.length > 0 && lang !== "" ? this.addItem : null}
                                onChange={this.handleChange} />
                        </div>
                    </DialogContent>
                    <DialogMultiActions onCancel={onCancel}>
                        <PrimaryButton dataTest="create-task" disabled={text === ""} onClick={this.createTask(false)}>Create</PrimaryButton>
                        {user !== "All" &&
                            <PrimaryButton disabled={text === ""} dataTest="create-task-notify" onClick={this.createTask(true)}>Create and Notify</PrimaryButton>
                        }
                    </DialogMultiActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

CreateTaskDialog.propTypes = {
    classes: PropTypes.object,
    createdBy: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onCreateTask: PropTypes.func.isRequired,
    defaultLang: PropTypes.string.isRequired,
    projectUsers: PropTypes.array
};

export default withStyles(styles)(CreateTaskDialog);